import styled from 'styled-components';
import { theme } from '@octane/spark';

export const Container = styled.div`
 ${theme.fontFamily.Karla};
  width: 500px;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-left: auto !important;
  margin-right: auto !important;

  @media (max-width: 520px) {
    width: 100%;
    padding: 0 10px;
  }
`;

export const Card = styled.div`
  padding: 20px;
  border-radius: 5px;
  background-color: ${theme.colors.monochrome.white};
`;
